import { useEffect, useState } from 'react';

function SoftHider(
  {
    children,
    show,
    loader = null,
  }: React.PropsWithChildren<{
    show: boolean,
    loader?: React.ReactElement | null,
  }>
) {
  const [hasScrolled, setHasScrolled] = useState(false);
  const display = (show) ? 'block' : 'none';
  const showLoader = !show && !!loader;

  // If we're showing the loader, it means content has changed or is in process of changing, and this
  // isn't always via a pathname change (as per ScrollToTop.tsx), so ensure we're 'resetting' the
  // scroll so that the user will be shown the new content once it's available.
  // Also using a state check to debounce the scroll call a little.
  useEffect(() => {
    if (showLoader && !hasScrolled) {
      window.scrollTo(0, 0);
      setHasScrolled(true);
    }
  }, [showLoader, hasScrolled]);

  return (
    <>
      {(showLoader) ? (
        loader
      ) : null}
      <div style={{ display }}>
        {children}
      </div>
    </>
  );
}

export default SoftHider;
